export enum BaseColors {
  WHITE = 'WHITE',
  GREY = 'GREY',
}

export enum DisplayValueTypes {
  startingPrice = 'startingPrice',
  offerCount = 'offerCount',
}
export enum FilterBoxCarTypesBackgroundColor {
  WHITE = 'WHITE',
  GREY = 'GREY',
  PURPLE = 'PURPLE',
  GREEN = 'GREEN',
  BLACK = 'BLACK',
}

export interface ICarTypesProps {
  _uid?: string;
  carType: string;
  description: string;
  price: number;
  searchUrl: string;
  priceFontColor: FilterBoxCarTypesBackgroundColor;
  displayValue: DisplayValueTypes;
  offersAmount: number;
}
export interface IFilterBoxCarTypesProps {
  heading: string;
  filterCarTypeItems: ICarTypesProps[];
  items: ICarTypesProps[];
  background?: BaseColors;
  priceFontColor?: FilterBoxCarTypesBackgroundColor;
  description?: string;
  displayValue?: DisplayValueTypes;
}
